import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from 'src/app/includes/dashboard/dashboard.service';
import { TemplatesService } from 'src/app/includes/templates/templates.service';
import { UserManagementService } from 'src/app/includes/user-management/user-management.service';
import { AuthService } from 'src/app/services/auth.service';
import * as global from '../../../includes/global';

@Component({
  selector: 'app-doctor-profile',
  templateUrl: './doctor-profile.component.html',
  styleUrls: [ './doctor-profile.component.css' ]
})
export class DoctorProfileComponent implements OnInit {
  defaultTabIndex: Number = 0;
  global = global;
  currentUser: any;
  userId;
  checkUrl;
  onlyProfile: boolean = false;
  showBar: boolean = false;
  showscriptSure:boolean = false;
  currentTab;
  userDetail: any;
  provider_id: string;
  constructor(
    private _route: ActivatedRoute,
    private authService: AuthService,
    private dashboardService: DashboardService,
    private userManagementService: UserManagementService,
  ) {
    if (this._route.snapshot.params.census) {
      this.defaultTabIndex = 1;
    }
  }

  ngOnInit(): void {
    this.provider_id = this._route.snapshot.params.provider_id
    this.userManagementService.currentTab.subscribe((currentTab: string) => {
      this.currentTab = currentTab;
    });
    if (this.currentTab && !this._route.snapshot.params.census) {
      this.defaultTabIndex = this.currentTab;
      // this.userManagementService.setCurrentTab(null);
    }
    this.currentUser = this.authService.currentUser;
    this.userId = this._route.snapshot.params.provider_id;
    this.getUser();
  }

  async getUser() {
    const response: any = await this.dashboardService.getUserDetail(this.userId).toPromise();
    if ( response.status == 200 ) {
      if([global.USER_TYPE.NURSE, global.USER_TYPE.MEDICAL_ASSISTANT, global.USER_TYPE.TRANSCRIBER, global.USER_TYPE.BILLER ].includes( response.data.array.user_type.toLowerCase())) {
        this.onlyProfile = true;
      }
      if ([global.USER_TYPE.DOCTOR , global.USER_TYPE.MEDICAL_ASSISTANT ].includes( response.data.array.user_type.toLowerCase())) {
        this.showscriptSure = true;
      }
    }

    this.userDetail = response.data.array;
    this.showBar = true;
  }

  changeCurrentTab( $event ) {
    this.defaultTabIndex = $event.index;
    this.userManagementService.setCurrentTab( $event.index );
  }
}
